export default class {
	constructor(obj) {
		this.id = obj.networkid
		this.name = obj.label
		this.code = obj.code
		this.beginDate = obj.begindate
		this.endDate = obj.enddate
		this.mnemonique = obj.mnemonique
		this.networkemprise = obj.networkemprise
		this.networktype = obj.networktype
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoDetailStationNetwork.js